import { NavigationWrapper } from '../../navigation-data';
import { ShiveRoutes } from '../../segments/route-segments';
import { UrlSegmentDelimiter } from '../../../constants-repository/app-style.constants';

export const UserProfile: NavigationWrapper = {
  title: 'User',
  route: ShiveRoutes.User,
};

export const UserProfileEdit: NavigationWrapper = {
  title: 'Benutzerdaten',
  route: ShiveRoutes.UserEdit + UrlSegmentDelimiter + ShiveRoutes.AnyId,
};

export const UserProfileAttachments: NavigationWrapper = {
  title: 'Anhänge',
  route: ShiveRoutes.UserAttachments + UrlSegmentDelimiter + ShiveRoutes.AnyId,
};
